export default "__VITE_ASSET__Cp9UlGEo__"